import { render, staticRenderFns } from "./MyGridGoodTable.vue?vue&type=template&id=108c376e&scoped=true&"
import script from "./MyGridGoodTable.vue?vue&type=script&lang=js&"
export * from "./MyGridGoodTable.vue?vue&type=script&lang=js&"
import style0 from "./MyGridGoodTable.vue?vue&type=style&index=0&id=108c376e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c376e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('108c376e')) {
      api.createRecord('108c376e', component.options)
    } else {
      api.reload('108c376e', component.options)
    }
    module.hot.accept("./MyGridGoodTable.vue?vue&type=template&id=108c376e&scoped=true&", function () {
      api.rerender('108c376e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyGridGoodTable.vue"
export default component.exports